import { render, staticRenderFns } from "./scopeOfWork.vue?vue&type=template&id=32ccceae&scoped=true"
import script from "./scopeOfWork.vue?vue&type=script&lang=js"
export * from "./scopeOfWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ccceae",
  null
  
)

export default component.exports